import { AuthUser, AuthUserSchema } from '@/contexts/auth';
import { api } from '@services/api';
import { SignInSchemaType } from '@apps/auth/schemas/signin';

export async function postSignIn(data: SignInSchemaType): Promise<AuthUser> {
  const response = await api.post(
    'accounts/authentication/authenticate-azure/',
    data,
  );
  return AuthUserSchema.parse(response.data);
}
